export enum CustomErrorStatusesEnum {
    ALREADY_EXIST_PRODUCTION_TIME = 601,
    // MACHINE_ALREADY_IN_USE = 602,
    PARENT_PROCESS_NOT_FINISHED = 603,
    USERS_LIMIT_LICENSE = 604,
    SCREENS_LIMIT_LICENSE = 605,
    NO_ACTIVE_SHIFT_SESSION = 606
}